import { currentLocale, type Locale } from "@/i18n";

const CURRENCY_CACHE = new Map<Locale, Intl.NumberFormat>();
const NUMBER_CACHE = new Map<Locale, Intl.NumberFormat>();

function currencyFormatter(): Intl.NumberFormat {
  const locale = currentLocale();
  let fmt = CURRENCY_CACHE.get(locale);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, { style: "currency", currency: "USD" });
    CURRENCY_CACHE.set(locale, fmt);
  }
  return fmt;
}

function numberFormatter(): Intl.NumberFormat {
  const locale = currentLocale();
  let fmt = NUMBER_CACHE.get(locale);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale);
    NUMBER_CACHE.set(locale, fmt);
  }
  return fmt;
}

export function formatCurrency(value: number): string {
  return currencyFormatter().format(value);
}

export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) return String(value);
  return numberFormatter().format(value);
}

const MONTH_SHORT: Record<Locale, readonly string[]> = {
  es: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  pt: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
};

export function formatMonthShort(isoDate: string): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  const labels = MONTH_SHORT[currentLocale()];
  return labels[date.getMonth()] ?? "";
}
